import * as React from "react";
import { styled } from "../../stitches.config";
import { StickyContainer, Sticky } from 'react-sticky';

import Adslot from '../Adslot'
import SeeAlsoArticles from "./Components/SeeAlsoArticles";
// import zobacz także bizon
import SeeAlsoArticlesBizon from "../../redesign/components/SeeAlsoArticles";
import SeeAlsoVideosBizon from "../../redesign/components/SeeAlsoVideos";
import {
  IS_FEATURE_adunityPartner
} from "../common/constants/constants"

import { useThemeContext } from "../../redesign/components/StitchesThemeProvider";

import { useBreakpoint, useStores, adSlotEnum, isEqualToKeyOrValue } from "../../helpers"


type ColumnHeightType = {
  column: number;
  container: number;
}

type ContainerStickyProps = {
  name: string;
  setHalfpageCount?: React.Dispatch<React.SetStateAction<number>>;
}

const RightColumn = () => {
  const { ArticleStore } = useStores();
  const isDesktop = (window.APP_SETTINGS.device === 'desktop');
  const isVideo = ArticleStore.article.display_type === "ARTICLE_VIDEO";
  const isPodcast = ArticleStore.article.display_type === "ARTICLE_PODCAST";
  const isLive = ArticleStore.article.display_type === "LIVE";
  const [halfpageVisible, setHalfpageVisible] = React.useState<boolean>(false);
  const [halfpageHeight, setHalfpageHeight] = React.useState<number>(0);
  const [halfpageHeightPlaceholder, setHalfpageHeightPlaceholder] = React.useState<number>(799);
  const [halfpageCount, setHalfpageCount] = React.useState<number>(0);
  const [columnHeight, setColumnHeight] = React.useState<ColumnHeightType>({
    column: 1110,
    container: 0,
  });
  const containerRef = React.useRef<HTMLDivElement>(null);
  const innerContainerRef = React.useRef<HTMLDivElement>(null);
  const halfpageRef = React.useRef<HTMLDivElement>(null);
  const isMaterialPartnera = ArticleStore.article.material_partnera;
  const adSuffix = ((IS_FEATURE_adunityPartner && isMaterialPartnera) ? '_partner' : '');

  const { isDarkMode } = useThemeContext();

  React.useEffect(() => {
    const { googletag } = window;
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener("slotRenderEnded", (event: any) => {
        const gptSlotId = event.slot.getSlotElementId()
        if (isEqualToKeyOrValue(gptSlotId, "ART_Halfpage_1" + adSuffix, adSlotEnum)) {
          setHalfpageVisible(true);
          //console.log({ curr: halfpageRef.current?.clientHeight })
        }
      });
    });
  }, []);

  React.useEffect(() => {
    recalculateHeight();
    //console.log(`right column recalculated: ${halfpageCount}`)
  }, [halfpageCount]);

  React.useEffect(() => {
    setHalfpageHeight((halfpageRef.current?.clientHeight || 0) + 400)
  }, [halfpageVisible])

  React.useEffect(() => {
    halfpageHeight > 400 && setHalfpageHeightPlaceholder((halfpageHeight))
  }, [halfpageHeight])

  const recalculateHeight = () => {
    if (containerRef?.current && innerContainerRef?.current) {
      // #6076 jak wysokość containera skacze (zdjęcia, reklamy, onnetwork), to moze wyciąć istniejącą reklamę, dlatego nie bierzemy aktualnej wysokosci, tylko max
      setColumnHeight({
        column: Math.max(containerRef.current.clientHeight, columnHeight.column),
        container: Math.max(innerContainerRef.current.clientHeight, columnHeight.container),
      });
    }
  };

  React.useEffect(() => {
    const resizeObserver = new ResizeObserver(e => {
      e.forEach(entry => {
        recalculateHeight();
      });
    });

    if (containerRef.current != null)
      resizeObserver.observe(containerRef.current);

    if (innerContainerRef.current != null)
      resizeObserver.observe(innerContainerRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  // const height: number = React.useMemo(() => halfpageVisible ? (halfpageRef.current?.clientHeight || 0) + 400 : 0, [halfpageVisible])
  return (
    <ArticleRightColumn isPodcast={isPodcast} isLive={isLive} isVideo={isVideo} ref={containerRef}>
      {!adSuffix && isDesktop && columnHeight.column > 1100 && (
        <div style={{ marginTop: 10, minHeight: halfpageHeightPlaceholder }} ref={halfpageRef}>
          <StickyContainer style={{ height: halfpageHeight }}>
            <Sticky topOffset={-43}>
              {({ style, isSticky }) => <StickyWrap style={style} isSticky={isSticky}>
                <div ref={halfpageRef}>
                  <Adslot name={"ART_Halfpage_1" + adSuffix} />
                </div>
              </StickyWrap>}
            </Sticky>
          </StickyContainer>
        </div>

      )}
      {isDesktop &&
        <>{isVideo ? (
          <SeeAlsoVideosBizon articles={ArticleStore.similar_articles} />
        ) : (
          <SeeAlsoArticlesBizon
            isDarkMode={isDarkMode}
            isPodcast={isPodcast}
            articles={ArticleStore.similar_articles}
            boxSize="small"
          />
        )} </>}
      <div ref={innerContainerRef} className="article-column__container">
        {isDesktop && columnHeight.container > 1200 && (
          <ContainerSticky
            name={"ART_Halfpage_2" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 2400 && (
          <ContainerSticky
            name={"ART_Halfpage_3" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 3600 && (
          <ContainerSticky
            name={"ART_Halfpage_4" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 4800 && (
          <ContainerSticky
            name={"ART_Halfpage_5" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 6000 && (
          <ContainerSticky
            name={"ART_Halfpage_6" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 7200 && (
          <ContainerSticky
            name={"ART_Halfpage_7" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 8400 && (
          <ContainerSticky
            name={"ART_Halfpage_8" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 9600 && (
          <ContainerSticky
            name={"ART_Halfpage_9" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
        {isDesktop && columnHeight.container > 10800 && (
          <ContainerSticky
            name={"ART_Halfpage_10" + adSuffix}
            setHalfpageCount={setHalfpageCount}
          />
        )}
      </div>
    </ArticleRightColumn>
  )
}

const ContainerSticky: React.FC<ContainerStickyProps> = ({ name, setHalfpageCount }) => {
  React.useEffect(() => {
    const { googletag } = window;
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener("slotRenderEnded", (event: any) => {
        const gptSlotId = event.slot.getSlotElementId()
        if (isEqualToKeyOrValue(gptSlotId, name, adSlotEnum)) {
          setHalfpageCount && setHalfpageCount(prev => prev + 1);
        }
      });
    });
  }, [])

  return (
    <StickyContainer className="article-column__sticky-container">
      <Sticky>
        {({ style }) => (
          <div style={{ ...style, paddingTop: "60px" }}>
            <Adslot name={name} />
          </div>
        )}
      </Sticky>
    </StickyContainer>
  );
}

const StickyWrap = styled("div", {
  variants: {
    "isSticky": {
      true: {
        paddingTop: "43px"
      },
      false: {}
    }
  }
});

export const ArticleRightColumn = styled("div", {
  "@bp4": {
    position: "absolute",
    left: "0",
    top: "0",
    bottom: "0",
    right: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    transition: "all 300ms",
    width: "300px",
    marginTop: "168px",
    marginLeft: "auto",
    "& > .article-column__container": {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      position: "relative",
      paddingBottom: "55px",
      "& > .article-column__sticky-container": {
        height: "1200px"
      },
      "& > [class~='article-column__sticky-container']:last-of-type": {
        /* max-height: none; */
        /* background-color: blue; */
        height: "auto",
        flexGrow: 1
      }
    }
  },
  variants: {
    "isVideo": {
      true: {
        marginTop: "226px"
      },
      false: {}
    },
    "isPodcast": {
      true: {
        marginTop: "80px"
      },
      false: {}
    },
    "isLive": {
      true: {
        marginTop: "48px"
      },
      false: {}
    }
  }
});

export default RightColumn;